/**
 * @flow
 * @relayHash 306e171cff746ec011fba449fabcd62e
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AuthTokenMutationVariables = {|
  username: string,
  password: string,
|};
export type AuthTokenMutationResponse = {|
  +tokenAuth: ?{|
    +token: ?string
  |}
|};
export type AuthTokenMutation = {|
  variables: AuthTokenMutationVariables,
  response: AuthTokenMutationResponse,
|};
*/

/*
mutation AuthTokenMutation(
  $username: String!
  $password: String!
) {
  tokenAuth(username: $username, password: $password) {
    token
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "username",
        type: "String!",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "password",
        type: "String!",
        defaultValue: null,
      },
    ],
    v1 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "tokenAuth",
        storageKey: null,
        args: [
          {
            kind: "Variable",
            name: "password",
            variableName: "password",
            type: "String!",
          },
          {
            kind: "Variable",
            name: "username",
            variableName: "username",
            type: "String!",
          },
        ],
        concreteType: "ObtainJSONWebToken",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "token",
            args: null,
            storageKey: null,
          },
        ],
      },
    ];
  return {
    kind: "Request",
    operationKind: "mutation",
    name: "AuthTokenMutation",
    id: null,
    text:
      "mutation AuthTokenMutation(\n  $username: String!\n  $password: String!\n) {\n  tokenAuth(username: $username, password: $password) {\n    token\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "AuthTokenMutation",
      type: "Mutations",
      metadata: null,
      argumentDefinitions: v0,
      selections: v1,
    },
    operation: {
      kind: "Operation",
      name: "AuthTokenMutation",
      argumentDefinitions: v0,
      selections: v1,
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '22579409bdb2f54fc36b128ba24f9203';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/AuthTokenMutation.graphql.js